import { Calendar, dayjsLocalizer } from "react-big-calendar";

import dayjs from "dayjs";
import { ComponentSpinner } from "../../spinner";
import { CardBody } from "reactstrap";
import classNames from "classnames";

const localizer = dayjsLocalizer(dayjs);

const ReactCalendar = ({
    events,
    loading,
    date = new Date(),
    className = "",
    onNavigate = () => {},
    onSelectSlot = () => {},
    onSelectEvent = () => {}
}) => {
    return (
        <CardBody>
            {loading ? (
                <ComponentSpinner />
            ) : (
                // @ts-ignore
                <Calendar
                    className={classNames("calendar-container", className)}
                    selectable
                    date={date}
                    localizer={localizer}
                    events={events}
                    startAccessor="start"
                    endAccessor="end"
                    onNavigate={onNavigate}
                    onSelectSlot={onSelectSlot}
                    onSelectEvent={onSelectEvent}/>
            )}
        </CardBody>
    );
};

export default ReactCalendar;